module.exports = __webpack_public_path__ + "img/user-20.9a6b5cc1.svg";